import React, { useState, useEffect } from "react"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Alert from "react-bootstrap/Alert"
import { serverAPI } from "../../services/api/apiParams"
import FavoritesCard from "./FavoritesCard"

function Favorites({ user }) {
  const [favorites, setFavorites] = useState()
  const [totalResults, setTotalResults] = useState(-1)

  useEffect(() => {
    const fetchFavorites = async () => {
      const res = await serverAPI.get("/api/recipes", {
        headers: { "Content-Type": "application/json" },
      })
      setFavorites(res.data)
      setTotalResults(res.data.length)
    }
    fetchFavorites()
  }, [])

  const deleteFav = async (recipe_id) => {
    try {
      await serverAPI.delete(`/api/recipes/${recipe_id}`, {
        headers: { "Content-Type": "application/json" },
      })
      setTotalResults((prev) => prev - 1)
      setFavorites((prev) => prev.filter((item) => item.id !== recipe_id))
    } catch (error) {
      console.log(error)
    }
  }

  if (user?.id == undefined) {
    return (
      <Alert className='mt-2 alert text-center popup-alert h-75'>
        You are not logged in. Please log in to access this page.
      </Alert>
    )
  }
  return (
    <Container bsPrefix='recipesContainer'>
      <Row>
        <Col sm={12} id='recipesId'>
          {totalResults === 0 ? (
            <Alert className='mt-5 alert'>No recipe found</Alert>
          ) : totalResults >= 1 ? (
            <>
              {favorites && (
                <FavoritesCard
                  recipes={favorites}
                  totalResults={totalResults}
                  deleteFav={deleteFav}></FavoritesCard>
              )}
            </>
          ) : (
            <Alert className='mt-5 alert'>Loading...</Alert>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default Favorites
